<template>
  <div class="advertisingManagement-view" :key="i18nUpdateKey">
    <commonTable :tableData="safeTableData"
                 :loading="loading"
                 :paginationVisible="false">
      <template v-slot:table>
        <el-table-column prop="type" align="center" :label="$t('business', 'imagePosition')" >
          <div class="operating" slot-scope="scope">
            <p>{{scope.row.type == 1 ? $t('business', 'mallSection') : scope.row.type == 2 ? $t('business', 'appointmentSection') : $t('business', 'dynamicSection')}}</p>
          </div>
        </el-table-column>

        <el-table-column prop="num" align="center" :label="$t('business', 'imageCount')" />
        <el-table-column :label="$t('business', 'operation')" align="center">
          <div class="operating" slot-scope="scope">
            <el-button size="mini" type="text" @click="edit_tap(scope.row)">{{ $t('business', 'edit') }}</el-button>
          </div>
        </el-table-column> 
      </template>
    </commonTable>
  </div>
</template>

<script>
import commonTable from "@/components/common/commonTable";
import {
  fetchPhotoType
} from "@/api/companyManage";
import i18nMixin from '@/mixins/i18nMixin';

export default {
  name: "advertisingManagement",
  mixins: [i18nMixin],
  components: {
    commonTable,
  },
  data() {
    return {
      tableData: [{
        type: 1,
        num: 0
      }, {
        type: 2,
        num: 0
      }, {
        type: 3,
        num: 0
      }],
      loading: false,
    };
  },
  computed: {
    // 确保数据有效性
    safeTableData() {
      return this.tableData || [];
    }
  },
  mounted(){
    this.getPhoto()
    
    // 监听语言变化，强制更新组件
    this.$root.$on('language-changed', () => {
      this.$forceUpdate();
    });
  },
  beforeDestroy() {
    // 清理事件监听
    this.$root.$off('language-changed');
  },
  methods:{
    getPhoto(){
      this.loading = true
      fetchPhotoType({ignore:true})
      .then(res=>{
        this.loading = false
        if (res.data && Array.isArray(res.data)) {
          res.data.forEach(item => {
            const index = item.type - 1;
            if (index >= 0 && index < this.tableData.length) {
              this.tableData[index].num = item.num || 0;
            }
          });
        }
      })
      .catch(err=>{
        this.loading = false
        console.log(err);
      })
    },
    //编辑
    edit_tap(item){
      let {type,num} = item
      
      this.$router.push(`./setBanner?type=${type}`) 
    }
  }
};
</script>

<style lang="scss" scoped>
.advertisingManagement-view{
  background: #ffff;
  padding: 24px;
}
.operating{
  .el-button--text{
    color: #51CBCD;
  }
}
</style>